import { render, staticRenderFns } from "./AddUpdateKnowledgeContentFolder.vue?vue&type=template&id=0261dd1e&"
import script from "./AddUpdateKnowledgeContentFolder.vue?vue&type=script&lang=js&"
export * from "./AddUpdateKnowledgeContentFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports